import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';
import type {BgRemoverUpsellData, BgRemoverUpsellPanelState} from './bg-remover-upsell-panel.types';
import {getBgRemoverUpsellData} from './bg-remover-upsell-panel-thunk';

const initialState: BgRemoverUpsellPanelState = {
  data: null,
  isLoading: false,
  hasFailed: false,
};

export const bgRemoverUpsellPanelSlice = createSlice({
  name: 'bgRemoverUpsellPanel',
  initialState,
  reducers: {
    resetBgRemoverUpsellPanel: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getBgRemoverUpsellData.pending, (state) => {
      state.isLoading = true;
      state.hasFailed = false;
    });
    builder.addCase(getBgRemoverUpsellData.fulfilled, (state, {payload}: PayloadAction<BgRemoverUpsellData>) => {
      state.data = payload;
      state.isLoading = false;
    });
    builder.addCase(getBgRemoverUpsellData.rejected, (state) => {
      state.isLoading = false;
      state.hasFailed = true;
    });
  },
});

export const {resetBgRemoverUpsellPanel} = bgRemoverUpsellPanelSlice.actions;
export const bgRemoverUpsellPanelReducer = bgRemoverUpsellPanelSlice.reducer;
